import * as React from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
import { MaterialIcon } from "ui-widgets";
import { ExplorerTableProps } from "models/explorer/explorer-table-props";
import ResultsTable from "./result-table";
import ArrowAnimation from "datalign-module-template/components/arrow-animation";

const ResultsList = ({
  pointsAndBoundaries,
  map,
  sendDisplayList,
}: ExplorerTableProps) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setIsOpen(open);
    };

  return (
    <>
      <Button
        hidden={pointsAndBoundaries.length === 0}
        variant="contained"
        color="warning"
        sx={{ borderRadius: 0, zIndex: 1200, position: "absolute", bottom: 0 }}
        fullWidth
        onClick={toggleDrawer(true)}
      >
        <MaterialIcon icon="expand_more" />
      </Button>
      <SwipeableDrawer
        disableBackdropTransition={true}
        hideBackdrop={true}
        anchor="bottom"
        open={isOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        sx={{ inset: "unset" }}
      >
        <Button
          variant="contained"
          color="warning"
          sx={{ borderRadius: 0, zIndex: 1200, position: "relative", top: 0 }}
          fullWidth
          onClick={toggleDrawer(false)}
        >
          <ArrowAnimation isOpen={isOpen} />
        </Button>
        <ResultsTable
          map={map}
          pointsAndBoundaries={pointsAndBoundaries}
          sendDisplayList={sendDisplayList}
        />
      </SwipeableDrawer>
    </>
  );
};

export default ResultsList;
